// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"8946c4ce","166":"54d374fb","184":"87afdda7","448":"2e27c85f","495":"9936b82e"}[chunkId] + ".chunk.css";
};